import SpecificHand from '@/services/hands/SpecificHand';
import constants from '@/services/constants';
import utilities from '@/services/utilities/utilities';
import _ from 'lodash';

export default {
  inRangeWithFirstRank: function (generalHands, firstRank) {
    let offsuitGeneralHandsInRangeWithFirstRank = this._getOffsuitGeneralHandsInRangeWithFirstRank(generalHands, firstRank);
    let groupsOfConsecutiveOffsuitGeneralHands = this._getGroupsOfConsecutiveOffsuitGeneralHands(offsuitGeneralHandsInRangeWithFirstRank);
    let textFromOffsuitGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveOffsuitGeneralHands(groupsOfConsecutiveOffsuitGeneralHands);

    return textFromOffsuitGeneralHandsWithFirstRank;
  },
  manuallyAddedWithFirstRank: function (generalHands, firstRank) {
    let offsuitGeneralHandsManuallyAddedWithFirstRank = this._getOffsuitGeneralHandsManuallyAddedWithFirstRank(generalHands, firstRank);
    let groupsOfConsecutiveOffsuitGeneralHands = this._getGroupsOfConsecutiveOffsuitGeneralHands(offsuitGeneralHandsManuallyAddedWithFirstRank);
    let textFromOffsuitGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveOffsuitGeneralHands(groupsOfConsecutiveOffsuitGeneralHands);

    return textFromOffsuitGeneralHandsWithFirstRank;
  },
  manuallyRemovedWithFirstRank: function (generalHands, firstRank) {
    let offsuitGeneralHandsManuallyRemovedWithFirstRank = this._getOffsuitGeneralHandsManuallyRemovedWithFirstRank(generalHands, firstRank);
    let groupsOfConsecutiveOffsuitGeneralHands = this._getGroupsOfConsecutiveOffsuitGeneralHands(offsuitGeneralHandsManuallyRemovedWithFirstRank);
    let textFromOffsuitGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveOffsuitGeneralHands(groupsOfConsecutiveOffsuitGeneralHands);

    return textFromOffsuitGeneralHandsWithFirstRank;
  },
  _getOffsuitGeneralHandsInRangeWithFirstRank: function (generalHands, firstRank) {
    let listOfOffsuitGeneralHandsInRangeWithFirstRank = [];

    constants.textSelectorLists.offsuit[firstRank].forEach(function (offsuitGeneralHandWithFirstRankString) {
      let offsuitGeneralHandWithFirstRank = generalHands.find(offsuitGeneralHandWithFirstRankString);

      if (offsuitGeneralHandWithFirstRank.inRange === true) {
        listOfOffsuitGeneralHandsInRangeWithFirstRank.push(offsuitGeneralHandWithFirstRank);
      } else if (offsuitGeneralHandWithFirstRank.inRange === 'partial') {
        offsuitGeneralHandWithFirstRank.forEachSpecificHandInRange(function (specificHand) {
          listOfOffsuitGeneralHandsInRangeWithFirstRank.push(specificHand);
        });
      }
    });

    return listOfOffsuitGeneralHandsInRangeWithFirstRank;
  },
  _getOffsuitGeneralHandsManuallyAddedWithFirstRank: function (generalHands, firstRank) {
    let listOfOffsuitGeneralHandsManuallyAddedWithFirstRank = [];

    constants.textSelectorLists.offsuit[firstRank].forEach(function (offsuitGeneralHandWithFirstRankString) {
      let offsuitGeneralHandWithFirstRank = generalHands.find(offsuitGeneralHandWithFirstRankString);

      if (offsuitGeneralHandWithFirstRank.manuallyAdded === true) {
        listOfOffsuitGeneralHandsManuallyAddedWithFirstRank.push(offsuitGeneralHandWithFirstRank);
      } else if (offsuitGeneralHandWithFirstRank.manuallyAdded === 'partial') {
        offsuitGeneralHandWithFirstRank.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyAdded) {
            listOfOffsuitGeneralHandsManuallyAddedWithFirstRank.push(specificHand);
          }
        });
      }
    });

    return listOfOffsuitGeneralHandsManuallyAddedWithFirstRank;
  },
  _getOffsuitGeneralHandsManuallyRemovedWithFirstRank: function (generalHands, firstRank) {
    let listOfOffsuitGeneralHandsManuallyRemovedWithFirstRank = [];

    constants.textSelectorLists.offsuit[firstRank].forEach(function (offsuitGeneralHandWithFirstRankString) {
      let offsuitGeneralHandWithFirstRank = generalHands.find(offsuitGeneralHandWithFirstRankString);

      if (offsuitGeneralHandWithFirstRank.manuallyRemoved === true) {
        listOfOffsuitGeneralHandsManuallyRemovedWithFirstRank.push(offsuitGeneralHandWithFirstRank);
      } else if (offsuitGeneralHandWithFirstRank.manuallyRemoved === 'partial') {
        offsuitGeneralHandWithFirstRank.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyRemoved) {
            listOfOffsuitGeneralHandsManuallyRemovedWithFirstRank.push(specificHand);
          }
        });
      }
    });

    return listOfOffsuitGeneralHandsManuallyRemovedWithFirstRank;
  },
  _getGroupsOfConsecutiveOffsuitGeneralHands: function (suitedGeneralHandsInRange) {
    let groupsOfConsecutiveOffsuitGeneralHands = [];
    let currGroupOfConsecutiveOffsuitGeneralHands = [];

    suitedGeneralHandsInRange.forEach(function (suitedGeneralHandInRange) {
      let suitedGeneralHandInRangeIsNextInOrder = this._isOffsuitGeneralHandInRangeNextInOrder(suitedGeneralHandInRange, _.last(currGroupOfConsecutiveOffsuitGeneralHands));

      if (
        (currGroupOfConsecutiveOffsuitGeneralHands.length === 0) ||
        (suitedGeneralHandInRangeIsNextInOrder)
      ) {
        currGroupOfConsecutiveOffsuitGeneralHands.push(suitedGeneralHandInRange);
      } else {
        groupsOfConsecutiveOffsuitGeneralHands.push(currGroupOfConsecutiveOffsuitGeneralHands);
        currGroupOfConsecutiveOffsuitGeneralHands = [];
        currGroupOfConsecutiveOffsuitGeneralHands.push(suitedGeneralHandInRange)
      }
    }, this);

    if (currGroupOfConsecutiveOffsuitGeneralHands.length > 0) {
      groupsOfConsecutiveOffsuitGeneralHands.push(currGroupOfConsecutiveOffsuitGeneralHands);
    }

    return groupsOfConsecutiveOffsuitGeneralHands;
  },
  _isOffsuitGeneralHandInRangeNextInOrder: function (currOffsuitGeneralHand, previousOffsuitGeneralHand) {
    if (currOffsuitGeneralHand instanceof SpecificHand) {
      return false;
    }

    if (!previousOffsuitGeneralHand) {
      return true;
    }

    let currOffsuitGeneralHandRank = currOffsuitGeneralHand.rankTwo;
    let previousOffsuitGeneralHandRank = previousOffsuitGeneralHand.rankTwo;

    return utilities.ranks.getRankOneLower(previousOffsuitGeneralHandRank) === currOffsuitGeneralHandRank;
  },
  _getTextFromGroupsOfConsecutiveOffsuitGeneralHands: function (groupsOfConsecutiveOffsuitGeneralHands) {
    let textFromGroupsOfConsecutiveOffsuitGeneralHands = '';

    groupsOfConsecutiveOffsuitGeneralHands.forEach(function (groupOfConsecutiveOffsuitGeneralHands) {
      textFromGroupsOfConsecutiveOffsuitGeneralHands += this._getTextFromGroupOfConsecutiveOffsuitGeneralHands(groupOfConsecutiveOffsuitGeneralHands) + ', ';
    }, this);

    return textFromGroupsOfConsecutiveOffsuitGeneralHands;
  },
  _getTextFromGroupOfConsecutiveOffsuitGeneralHands: function (groupOfConsecutiveOffsuitGeneralHands) {
    let firstOffsuitGeneralHand = groupOfConsecutiveOffsuitGeneralHands[0];
    let lastOffsuitGeneralHand = _.last(groupOfConsecutiveOffsuitGeneralHands);
    let biggestPossibleSecondRank = utilities.ranks.getRankOneLower(firstOffsuitGeneralHand.rankOne);
    let secondRankOfFirstOffsuitGeneralHand = firstOffsuitGeneralHand.rankTwo;
    let secondRankOfLastOffsuitGeneralHand = lastOffsuitGeneralHand.rankTwo;

    if (groupOfConsecutiveOffsuitGeneralHands.length === 1) {
      return firstOffsuitGeneralHand.string;
    } else {
      return firstOffsuitGeneralHand.string + '-' + lastOffsuitGeneralHand.string;
    }
  },
};



// WEBPACK FOOTER //
// ./src/services/text/get-text-from-general-hands/get-text-from-offsuit-general-hands.js